import { Tonality } from '@dsny/dsny-component-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Province } from 'src/consts/ProvincesData';
import {
  ComboboxInputStyles,
  ComboboxOptionWrapper,
  ComboboxStyles,
  ComboboxWrapperState,
  ComboboxPopoverStylesCountryState,
  InlineMessage,
  ItemWrapper,
  InputLabelStyles,
} from './SignupFields.styles';

interface Props {
  onSelect: (item?: Province) => void;
  provinces: Province[];
  ref?: null;
  error: boolean;
}

const SignupProvince: React.FC<Props> = ({ error, provinces, onSelect }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string>('');

  const openCombobox = () => {
    setOpen(true);
  };

  const closeCombobox = () => {
    setOpen(false);
  };

  // Handling province selection
  const onChange = (option: string) => {
    setValue(option);
    onSelect(provinces.find((item) => item.description === option));
  };

  return (
    <>
      {/* Province */}
      <ComboboxWrapperState>
        <Tonality.Combobox
          label={t('SIGNUP_PROVINCE_LABEL')}
          isOpen={open}
          onClick={openCombobox}
          onClose={closeCombobox}
          onChange={onChange}
          value={value}
          setting="mtr"
          style={{ ...ComboboxStyles }}
        >
          <Tonality.ComboboxInput
            placeholder={t('SIGNUP_SELECT_PLACEHOLDER')}
            required
            hasError={error}
            style={{ ...ComboboxInputStyles }}
            inputLabelStyles={{ ...InputLabelStyles }}
          />
          <Tonality.ComboboxPopover
            style={{ ...ComboboxPopoverStylesCountryState }}
          >
            <Tonality.ComboboxList
              style={{ paddingTop: '16px', paddingBottom: '16px' }}
            >
              {provinces?.map((p: Province) => (
                <ComboboxOptionWrapper
                  key={p.id}
                  value={p.description}
                  isSelected={p.description === value}
                  style={{ paddingLeft: '16px' }}
                >
                  <ItemWrapper>{p.description}</ItemWrapper>
                </ComboboxOptionWrapper>
              ))}
            </Tonality.ComboboxList>
          </Tonality.ComboboxPopover>

          {/* If not selected apply inline message  */}
          {error && (
            <InlineMessage $inlineMessage>
              {t('SIGNUP_PROVINCE_ERROR_MESSAGE')}
            </InlineMessage>
          )}
        </Tonality.Combobox>
      </ComboboxWrapperState>
    </>
  );
};

export default SignupProvince;
